import { createFileRoute } from "@tanstack/react-router";
import AdminPage from "lib/components/admin/builders/AdminPage";
import DataMigrationDashboard from "lib/components/admin/dataMigrations/DataMigrationDashboard";
import withAuthentication from "../../../components/withAuthentication";

function DataMigrationPage() {
  return (
    <AdminPage currentPage="data-migration" pageTitle="Data Migration">
      <DataMigrationDashboard />
    </AdminPage>
  );
}

export const Route = createFileRoute("/admin/data-migration/")({
  component: withAuthentication(DataMigrationPage, { superAdmin: true }),
});
